<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Evaluation/Final/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>